module.exports = "/_next/static/images/889b58f958f05e521f8daa1d571d1f33-double-card@md-1x.png.webp";